import router from '../../../../routers/index'
import { isNumber } from '../../../../utils/base'
import { WZ } from '../../../../common/globals'

// 通用跳转
function goPush(_ctx, location) {
  router.push(location)
  // dispatch('log/pv', location, {
  //     root: true
  // })
}

function goReplace(_ctx, location) {
  router.replace(location)
  // dispatch('log/pv', location, {
  //     root: true
  // })
}

function goBack(_ctx, n) {
  n = n && isNumber(n) ? n : -1
  router.go(n)
}

function goLogin({ dispatch }, opts) {
  opts = opts || {}
  const redirectUrl = opts.redirectUrl || location.href
  dispatch('goPush', {
    name: 'login',
    query: {
      redirectUrl
    }
  })
}

function goLogout({ dispatch }, opts) {
  opts = opts || {}
  const redirectUrl = opts.redirectUrl || location.href
  dispatch('goReplace', {
    name: 'logout',
    query: {
      redirectUrl
    }
  })
}

function goRegister({ dispatch }, opts) {
  opts = opts || {}
  const redirectUrl = opts.redirectUrl || location.href
  dispatch('goPush', {
    name: 'register',
    query: {
      redirectUrl
    }
  })
}

function goRealname(_ctx, opts) {
  //   opts = opts || {}
  //   const redirectUrl = opts.redirectUrl || location.href
  //   let url = `https://${HOST_WEB}/account/realname`
  // //   console.log(redirectUrl)
  //   if(redirectUrl) {
  //       url+= '?redirectUrl=' + encodeURIComponent(redirectUrl)
  //   }
  //   WZ.go(url)
  WZ.go('realname', opts)
}

export { goPush, goReplace, goBack, goLogin, goLogout, goRegister, goRealname }
